/**
  * CONEO-WD2C機能ルートパス
  */
export const coneoWd2cRoot = 'wd2c';

/**
  * CONEO-WD2C機能のメニュー定義
  */
export const coneoWd2cConfig: {label: string; menuItems: {label: string, path: string}[]} = {
  label: 'CONEO-WD2C',
  menuItems: [
    { label: '出荷手法選択', path: coneoWd2cRoot + '/dashboards' },
    { label: 'KPI', path: coneoWd2cRoot + '/kpi' },
  ],
};
 